var React = require('react');

function StepArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.2114 0.000244141L32.6206 2.59314L44.1496 14.1311H0V17.798H44.1496L32.6206 29.3358L35.2114 31.9287L51.1634 15.9644L35.2114 0.000244141Z","fill":"#E2E6EC"}));
}

StepArrowInline.defaultProps = {"width":"52","height":"32","viewBox":"0 0 52 32","fill":"none"};

module.exports = StepArrowInline;

StepArrowInline.default = StepArrowInline;
